'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoArrowLeftB = function IoArrowLeftB(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm25.5 7.7c0.2-0.1 0.5-0.2 0.8-0.2 0.7 0 1.2 0.6 1.2 1.3v22.4c0 0.7-0.5 1.3-1.2 1.3-0.3 0-0.6-0.1-0.8-0.2l-0.1-0.2-12.2-10.6c-0.4-0.4-0.7-0.9-0.7-1.5s0.3-1.1 0.7-1.5l12.2-10.6z' })
        )
    );
};

exports.default = IoArrowLeftB;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/arrow-left-b.js
// module id = 1969
// module chunks = 0